<template>
    <div>
      <liable-field-list></liable-field-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>